export enum UserRole {
  ADMIN = "ROLE_CUSTOMER_ADMIN",
  CLIENT = "ROLE_CUSTOMER",
}
